export default "__VITE_ASSET__DqBjs2AV__"